import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetDepartamentsQuery } from "../../hooks/useGetDepartamentsQuery";
import { setUpdateDepartamentData } from "../../redux/slices/school/departament";
import { routes } from "../../routes";
import { updateDepartament } from "../../services/school/departament/updateDepartament";
import { DepartamentType, UpdateDepartamentType } from "../../types/Departament";
import { setPreviousPath } from "../../redux/slices/previousPath";


const columnNamesMap: { [key: string]: string } = {
    description: 'Departamento',
    faculty: 'Unidade orgânica',
    province: "Província",
};
export const Departaments = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetDepartamentsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdateDepartament = useMutation(updateDepartament, {
        onSuccess: () => {
            queryClient.invalidateQueries('departaments-pagination');
            toast.success('Departamento apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar Unidade orgânica.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createDepartament)
    }
    const handleEdit = (departament: DepartamentType) => {
        dispatch(setUpdateDepartamentData(departament));
        navigate(routes.updateDepartament)
    };
    const handleDelete = (departament: UpdateDepartamentType) => {
        departament.status = false;
        mutationUpdateDepartament.mutateAsync(departament)
    };

    const handleAssignManagers = (departament: DepartamentType) => {
        dispatch(setUpdateDepartamentData(departament));
        dispatch(setPreviousPath(routes.departaments))
        navigate(routes.assignManager)

    };

    const options = data?.items.map(() => [
        {
            label: 'Editar',
            onClick: (departament: UpdateDepartamentType) => handleEdit(departament),
            icon: <Pencil1Icon />
        },
        {
            label: 'Vincular responsável',
            onClick: (departament: UpdateDepartamentType) => handleAssignManagers(departament),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: (departament: UpdateDepartamentType) => handleDelete(departament),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={Object.keys(columnNamesMap)}
                    items={data?.items}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleClickCreate}
        />
    );
}